import { Button } from "@/shared/ui/button";
import { BookOpen, ExternalLink } from "lucide-react";
import type { SpecSheetRef } from "@/features/assets/types/lookupAssetSpecs";

export function SpecSheetRow({
  sheet,
  badgeLabel,
  onOpen,
}: {
  sheet: SpecSheetRef;
  badgeLabel: string;
  onOpen: (fileUrl: string) => void;
}) {
  const cleanedDocType = sheet.document_type?.replace(/_/g, ' ').trim() ?? '';
  const cleanedManufacturer = sheet.manufacturer?.trim() ?? '';
  const isUnknown = (value: string) => !value || value.toLowerCase() === 'unknown';
  const title = !isUnknown(cleanedDocType)
    ? cleanedDocType
    : !isUnknown(cleanedManufacturer)
      ? cleanedManufacturer
      : 'PDF';

  // `badgeLabel` is intentionally not rendered — the drawer hides the
  // Primary/Related distinction in the UI (kept in the prop signature so
  // callers can stay declarative if we want to bring it back).
  void badgeLabel;
  return (
    <div className="flex items-center justify-between gap-3 p-4 rounded-lg border-2 border-border hover:border-primary transition-all duration-300 group">
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <div className="p-3 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors shrink-0">
          <BookOpen className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0 space-y-1">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="font-semibold truncate">{title}</p>
          </div>
          {!isUnknown(cleanedManufacturer) && cleanedManufacturer !== title && (
            <p className="text-xs text-muted-foreground truncate">{cleanedManufacturer}</p>
          )}
        </div>
      </div>
      <div className="flex shrink-0 gap-2">
        <Button
          size="sm"
          variant="outline"
          className="gap-1"
          onClick={() => onOpen(sheet.file_url)}
        >
          <ExternalLink className="h-4 w-4" />
          Open
        </Button>
      </div>
    </div>
  );
}
